<template>
  <v-btn-form ref="btnForm" :title="title" @close="cancel()">
    <v-form v-model="valid" ref="form">
      <v-card >
        <v-layout column v-show="!isNew">
        <v-card-title style="display: block; overflow-wrap: break-word;">
          <v-flex>
           <span class="headline" >{{fileItem.docName}}</span>
           <v-flex class="caption" v-if="fileItem.signed">Документ заверен, после загрузки новой версии необходимо снова заверить документ</v-flex>
            <!-- <v-component :is="renderDepoFileSignature(fileItem)"></v-component> -->
          </v-flex>
        </v-card-title>
        </v-layout>
        <v-card-text>
        <v-layout v-if="isNew" column>
          <v-flex xs12>
            <v-layout row wrap>
              <template v-for="item in files">
              <div><v-tooltip bottom open-delay="500" max-width="20em">
              <div slot="activator">
              <v-chip
                :key = item.name
                small
                :text-color="errorFileMessage(item) ? 'error' : 'black'"
                @click="pickFile"
                close
                @input="item.remove"
                >
                <span class="text-xs-center">
                  {{item.name.slice(0, 30)}}
                </span>
              </v-chip>
                </div>
                <span style="overflow-wrap: break-word">{{item.name}}</span>
                <div class="error" light>{{errorFileMessage(item)}}</div>
              </v-tooltip></div>
              </template>
              <v-chip
                small
                disabled
                text-color="secondary"
                @click="pickFile"
                v-show="files.length === 0"
                >
                <span class="text-xs-center">
                Выбрать файл для депонирования
                </span>
              </v-chip>
              <input
                type="file"
                style="display: none"
                ref="image"
                @change="onFilePicked"
                :accept="getAcceptedFileFormat()"
                multiple
              >

            </v-layout>
          </v-flex>
          <v-flex>
            <v-text-field
              label="Название"
              hint="Название документа может не совпадать с именем файла"
              v-model="fileItem.docName"
              :disabled="files.length > 1"
              clearable
            ></v-text-field>
          </v-flex>
          <v-flex>
            <v-date-field
              label="Депонировать до:"
              hint="Дата, до которой файл доступен в депозитарии"
              v-model="deleted"
            >
            </v-date-field>
          </v-flex>
          <v-flex>
            <v-textarea
              label="Примечания"
              rows="2"
              hint="Примечания видны только для пользователей депонента"
              v-model="fileItem.desc"
              v-show="isNew"
              clearable
            ></v-textarea>
          </v-flex>
          <v-flex>
            <v-textarea
              label="Поисковые теги"
              hint="Поисковые теги используются для поиска по документам депонента"
              rows="1"
              v-model="fileItem.tags"
              v-show="isNew"
              clearable
            ></v-textarea>
          </v-flex>
        </v-layout>

      <v-layout column v-if="!isNew">
        <v-flex>
          Депонировано: <b>{{formats.blank(fileItem.uploaded, formats.formatDateTime)}}</b> (по:&nbsp{{formats.blank(fileItem.deleted, formats.formatDate)}})
        </v-flex>
        <v-flex>
          <span> Депонент:&nbsp<b>{{fileItem.ownerShortName}}</b>
           ИНН:&nbsp<b>{{formats.formatInn(fileItem.ownerInn)}}</b></span>
        </v-flex>
        <v-flex>
          <span class="caption">Вы можете загрузить в депозитарий новую версию документа и использовать новую ссылку. Использование старой ссылки позволит видеть историю изменений. </span>
        </v-flex>

        <v-flex>
          <v-text-field
            label="Название"
            hint="Название документа может не совпадать с именем файла"
            v-model="fileItem.docName"
            clearable
          ></v-text-field>
        </v-flex>
        <v-flex>
          <v-date-field
            label="Депонировать до:"
            hint="Дата, до которой файл доступен в депозитарии"
            v-model="deleted"
          >
          </v-date-field>
        </v-flex>
        <v-flex >
            <v-layout row wrap v-if="!oldBody">
              <template v-for="item in files">
              <div><v-tooltip bottom open-delay="500" max-width="20em">
              <div slot="activator">
              <v-chip
                :key = item.name
                small
                :text-color="errorFileMessage(item) ? 'error' : 'black'"
                @click="pickFile"
                close
                @input="item.remove"
                >
                <span class="text-xs-center">
                  {{item.name.slice(0, 30)}}
                </span>
              </v-chip>
                </div>
                <span style="overflow-wrap: break-word">{{item.name}}</span>
                <div class="error" light>{{errorFileMessage(item)}}</div>
              </v-tooltip></div>
              </template>
              <v-chip
                small
                disabled
                text-color="secondary"
                @click="pickFile"
                v-show="files.length === 0"
                >
                <span class="text-xs-center">
                Выбрать файл для депонирования
                </span>
              </v-chip>
            <input
              type="file"
              style="display: none"
              ref="image"
              @change="onFilePicked"
              :accept="getAcceptedFileFormat()"
            >
          </v-layout>
          <v-flex pl-4 pt-1>
            <v-checkbox label="не загружать файл" persistent-hint color="secondary"
              hint="Версия создается для изменения атрибутов" v-model="oldBody"></v-checkbox>
          </v-flex>
        </v-flex>
      </v-layout>
      </v-card-text>
    <v-card-actions>
      <v-btn :disabled="disableUpload()" @click="upload">Загрузить</v-btn>
    </v-card-actions>
    </v-card>
  </v-form>
</v-btn-form>
</template>

<script type="text/javascript">
  // import Vue from 'vue'
  import { mapGetters } from 'vuex'
  import formats from '../../api/formats'
  import files from '../../api/files'
  import utils from '../../api/utils'
  import apimix from '../common/apimix'
  import moment from 'moment'
  import vDateField from '../common/DateField.vue'
  import vBtnForm from '../common/BtnForm'

  export default {
    name: 'doc-new',
    components: {vDateField, vBtnForm},
    mixins: [apimix],
    data: () => ({
      isProcessing: false,
      oldBody: true,
      valid: false,
      imageFile: null,
      files: [],
      fileItem: null,
      oldFileItem: null,
      errorMessage: null
    }),
    props: {
      toolbar: {
        type: Boolean,
        default: false
      },
      fileItemId: {
        type: String,
        default: null
      },
      newPath: {
        type: String,
        default: '/'
      },
      newTags: {
        type: String,
        default: ''
      }
    },
    created () {
      this.fileItem = this.getFileItemNew()
      this.fetchData(this.fileItemId)
    },
    mounted () {
      this.fileItem.tags = this.newTags ? this.newTags.concat(this.fileItem.tags) : this.fileItem.tags
    },
    watch: {
      fileItemId: function (newVal, oldVal) { // watch it
        this.fetchData(newVal)
      }
    },
    computed: {
      ...mapGetters({
        getDepoDisplayPaths: 'getDepoDisplayPaths',
        getOpenSettings: 'getOpenSettings',
        renderDepoFileSignature: 'renderDepoFileSignature',
        getDepoUrl: 'getDepoUrl'
      }),
      isNew () {
        return this.fileItemId === null
      },
      title () {
        return this.isNew ? 'Депонирование файла' : 'Депонирование новой версии файла'
      },
      deleted: {
        get () {
          return new Date(this.fileItem.deleted).toISOString()
        },
        set (value) {
          this.fileItem.deleted = value
        }
      }
    },
    methods: {
      errorFileMessage (file) {
        return files.errorFileMessage(file)
      },
      fetchData (itemId) {
        if (itemId) {
          this.$store.dispatch('getDepoFile', itemId).then(
            (fs) => {
              this.oldFileItem = fs && fs.length ? fs[0] : null
              if (this.oldFileItem) {
                this.fileItem = Object.assign({}, this.oldFileItem, this.getFileVersionNew())
                this.fileItem.prevUid = this.oldFileItem.uid
              } else {
                this.fileItem = Object.assign({}, this.getFileItemNew())
              }
              this.oldBody = false
            },
            () => {})
        } else {
          this.fileItem = this.getFileItemNew()
          this.fileItem.path = this.newPath
        }
      },
      getAcceptedFileFormat () {
        return '.pdf, .docx, .rtf, .csv, xlsx, .pptx, .odt, .ods, .odp, image/*'
      },
      disableUpload () {
        if (this.isProcessing) {
          return true
        }
        if (this.isNew || !this.oldBody) {
          var filesErrors = this.files.reduce((s, file) => s || this.errorFileMessage(file), null) !== null
          return !this.valid || this.files.length < 1 || filesErrors
        } else {
          return this.oldFileItem && this.oldFileItem.docName === this.fileItem.docName && formats.formatDate(this.oldFileItem.deleted) === formats.formatDate(this.fileItem.deleted)
        }
      },
      upload () {
        if (this.isProcessing) {
          return
        }
        if (this.$refs.form.validate()) {
          this.isProcessing = true
          if (this.isNew || !this.oldBody) {
            this.$store.dispatch('uploadDepoFiles', {docItem: this.fileItem, files: this.files}).then(uids => this.onUploaded(uids))
          } else {
            this.$store.dispatch('uploadDepoFile', {fileItem: this.fileItem, file: null}).then(uid => this.onUploaded([uid]))
          }
        }
      },
      onUploaded (uids) {
        this.isProcessing = false
        this.$emit('input', uids)
        this.cancel()
      },
      cancel () {
        this.fileItem = Object.assign({}, this.getFileItemNew())
        this.$emit('close')
      },
      pickFile () {
        this.$refs.image.click()
      },
      onUpdateFiles () {
        if (this.isNew) {
          if (this.files.length === 1) {
            this.fileItem.docName = this.files[0].name.substring(0, this.files[0].name.lastIndexOf('.'))
          } else {
            this.fileItem.docName = ''
          }
        }
      },
      addFile (file) {
        var self = this
        const add = (file) => {
          console.log('addFile', file)
          file.remove = function (e) {
            !e && self.deleteFile(file)
          }
          this.files.push(file)
          this.onUpdateFiles()
        }
        if (!this.files.find(f => formats.compareString(f.name, file.name) === 0)) {
          utils.compress(file, add, {})
        }
      },
      deleteFile (file) {
        this.files = this.files.filter(f => formats.compareString(f.name, file.name) !== 0)
        this.onUpdateFiles()
      },
      onFilePicked (e) {
        const files = Array.from(e.target.files)
        const readFile = (file, cb) => {
          var reader = new FileReader()
          reader.onload = () => {
            cb(file)
          }
          reader.readAsDataURL(file)
        }
        const addFile = (file) => this.addFile(file)
        if (files.length > 0) {
          files.forEach((f) => readFile(f, (file) => {
            addFile(file)
          }))
        }
      },
      getDeleted (dateTime) {
        return new Date(dateTime)
      },
      getFileItemNew () {
        return {
          uid: null,
          fileNo: null,
          fileName: null,
          fileExt: null,
          fileSize: null,
          docName: null,
          desc: null,
          ownerInn: null,
          ownerNameShort: null,
          account: null,
          uploaded: null,
          path: '/',
          tags: '',
          folder: null,
          deleted: moment().add(7, 'years').format()
        }
      },
      getFileVersionNew () {
        return {
          uid: null,
          fileNo: null,
          fileName: null,
          fileExt: null,
          fileSize: null
        }
      },
      getDisplayPath (path) {
        return this.getDepoDisplayPaths ? this.getDepoDisplayPaths.get(path) : ''
      },
      getDisplayPaths () {
        var map = this.getDepoDisplayPaths
        var result = []
        if (!map) {
          return result
        }
        map.forEach((val, key) => result.push({key: key, value: val}))
        // console.log('getDisplayPaths', result)
        return result.sort((a, b) => formats.compareString(a.value, b.value))
      }
    }
  }

</script>




// WEBPACK FOOTER //
// DocNew.vue?2285c3fa